import type { ReactNode } from 'react'
import type { Tone } from '@/components/ui/Badge'
import { Widget } from '@/components/ui/Widget'
import styles from './KpiCard.module.css'

export interface Stat {
  label: string
  value: ReactNode
  tone?: Tone
}

interface KpiCardProps {
  title: ReactNode
  headline: { value: ReactNode; label: string }[]
  stats: Stat[]
  loading?: boolean
  actions?: ReactNode
  className?: string
  /** Optional extra content under the stat tiles (sparkline, notes). */
  children?: ReactNode
}

/** Product summary card: a couple of headline counters and a row of coloured stat tiles. */
export function KpiCard({ title, headline, stats, loading, actions, className, children }: KpiCardProps) {
  return (
    <Widget title={title} loading={loading} actions={actions} className={className}>
      <div className={styles.head}>
        {headline.map((h) => (
          <span key={h.label}>
            <strong>{h.value}</strong> {h.label}
          </span>
        ))}
      </div>
      <div className={styles.statsWrap}>
        <div className={styles.stats} data-count={stats.length}>
          {stats.map((stat) => (
            <div key={stat.label} className={`${styles.stat} ${stat.tone && stat.tone !== 'neutral' ? styles[stat.tone] : ''}`}>
              <div className={styles.statLabel}>{stat.label}</div>
              <div className={styles.statValue}>{stat.value}</div>
            </div>
          ))}
        </div>
      </div>
      {children && <div className={styles.extra}>{children}</div>}
    </Widget>
  )
}
